import React from 'react';
import { G, Line, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** Mixed air enthalpy — same AHU mixing topology with enthalpy badges. */
export function DiagramMixedAirEnthalpy() {
  const ax = 110, ay = 50, aw = 130, ah = 165;

  return (
    <DiagramCanvas>
      {/* AHU casing */}
      <Rect x={ax} y={ay} width={aw} height={ah} fill={DT.fill} stroke={DT.stroke} strokeWidth="2" rx="4" />
      <SvgText x={ax + aw / 2} y={ay - 4} fill={DT.desc} fontSize="9" fontFamily={DT.mono} textAnchor="middle">AHU mixing box</SvgText>

      {/* OA — cool tint */}
      <Rect x={20} y={ay + 12} width={ax - 20} height={28} fill="rgba(122,170,187,0.22)" stroke={DT.stroke} strokeWidth="1.5" />
      {[0, 1, 2].map(i => (
        <Line key={i} x1={ax - 28 + i * 6} y1={ay + 12} x2={ax - 22 + i * 6} y2={ay + 40}
          stroke={DT.varColor} strokeWidth="1.4" />
      ))}
      <Line x1={28} y1={ay + 26} x2={ax - 6} y2={ay + 26} stroke={DT.arrow} strokeWidth="1.6" />
      <Polygon points={`${ax - 4},${ay + 26} ${ax - 10},${ay + 22} ${ax - 10},${ay + 30}`} fill={DT.arrow} />
      <Rect x={26} y={ay + 1} width={50} height={11} fill="rgba(122,170,187,0.85)" rx="2" />
      <SvgText x={51} y={ay + 10} fill="#0D1B2A" fontSize="8.5" fontFamily={DT.mono} fontWeight="700" textAnchor="middle">h_OA</SvgText>

      {/* RA — warm tint */}
      <Rect x={20} y={ay + ah - 40} width={ax - 20} height={28} fill="rgba(255,107,26,0.22)" stroke={DT.stroke} strokeWidth="1.5" />
      {[0, 1, 2].map(i => (
        <Line key={i} x1={ax - 28 + i * 6} y1={ay + ah - 12} x2={ax - 22 + i * 6} y2={ay + ah - 40}
          stroke={DT.varColor} strokeWidth="1.4" />
      ))}
      <Line x1={28} y1={ay + ah - 26} x2={ax - 6} y2={ay + ah - 26} stroke={DT.arrow} strokeWidth="1.6" />
      <Polygon points={`${ax - 4},${ay + ah - 26} ${ax - 10},${ay + ah - 30} ${ax - 10},${ay + ah - 22}`} fill={DT.arrow} />
      <Rect x={26} y={ay + ah - 11} width={50} height={11} fill="rgba(255,107,26,0.85)" rx="2" />
      <SvgText x={51} y={ay + ah - 3} fill="#0D1B2A" fontSize="8.5" fontFamily={DT.mono} fontWeight="700" textAnchor="middle">h_RA</SvgText>

      {/* Mixing turbulence */}
      <Polygon points={`${ax + 30},${ay + 50} ${ax + 60},${ay + 75} ${ax + 30},${ay + 100} ${ax + 60},${ay + 125}`}
        fill="none" stroke={DT.leader} strokeWidth="1" opacity={0.5} />
      {/* Enthalpy unit reminder */}
      <SvgText x={ax + aw / 2} y={ay + ah / 2 + 4} fill={DT.desc} fontSize="9" fontFamily={DT.mono} textAnchor="middle">BTU/lb</SvgText>

      {/* SA out */}
      <Rect x={ax + aw} y={ay + ah / 2 - 16} width={330 - (ax + aw)} height={32}
        fill="rgba(230,180,140,0.18)" stroke={DT.stroke} strokeWidth="1.5" />
      <Line x1={ax + aw + 8} y1={ay + ah / 2} x2={325} y2={ay + ah / 2} stroke={DT.arrow} strokeWidth="1.6" />
      <Polygon points={`325,${ay + ah / 2} 319,${ay + ah / 2 - 4} 319,${ay + ah / 2 + 4}`} fill={DT.arrow} />
      <Rect x={ax + aw + 14} y={ay + ah / 2 - 30} width={56} height={11} fill="rgba(230,180,140,0.85)" rx="2" />
      <SvgText x={ax + aw + 42} y={ay + ah / 2 - 22} fill="#0D1B2A" fontSize="8.5" fontFamily={DT.mono} fontWeight="700" textAnchor="middle">h_MA</SvgText>

      {/* Labels */}
      <LeaderLine x1={70} y1={ay + 26} x2={20} y2={210} varName="Q_OA · h_OA" desc="cool/dry stream" anchor="start" />
      <LeaderLine x1={70} y1={ay + ah - 26} x2={150} y2={210} varName="Q_RA · h_RA" desc="warm/humid stream" anchor="middle" />
      <LeaderLine x1={290} y1={ay + ah / 2} x2={310} y2={210} varName="h_MA" desc="BTU/lb" anchor="end" />

      <FormulaTag formula="h_MA = (Q_OA·h_OA + Q_RA·h_RA) / Q_SA" />
    </DiagramCanvas>
  );
}
